/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Addr_Wiz_BadgeInputs */

const cs_addr_wiz_badge = /** @type {(inputs: Addr_Wiz_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} návrhů adresy`)
};

const en_addr_wiz_badge = /** @type {(inputs: Addr_Wiz_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} address suggestions`)
};

/**
* | output |
* | --- |
* | "{count} address suggestions" |
*
* @param {Addr_Wiz_BadgeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_wiz_badge = /** @type {((inputs: Addr_Wiz_BadgeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Wiz_BadgeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_wiz_badge(inputs)
	return cs_addr_wiz_badge(inputs)
});